import {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Typography} from '@/components/ui/typography';

const SIGN_OUT_TIMEOUT_SECONDS = 10;

type WorkTimeSignOutCountdownProps = {
  onComplete: () => void;
};

function WorkTimeSignOutCountdown({onComplete}: WorkTimeSignOutCountdownProps) {
  const {t} = useTranslation();
  const [secondsLeft, setSecondsLeft] = useState(SIGN_OUT_TIMEOUT_SECONDS);
  const onCompleteRef = useRef(onComplete);

  onCompleteRef.current = onComplete;

  useEffect(() => {
    let remainingSeconds = SIGN_OUT_TIMEOUT_SECONDS;

    const interval = window.setInterval(() => {
      remainingSeconds -= 1;
      setSecondsLeft(remainingSeconds);

      if (remainingSeconds === 0) {
        window.clearInterval(interval);
        onCompleteRef.current();
      }
    }, 1_000);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <Typography>
      {t(
        'Your work will be finished and you will be signed out automatically in {{count}} seconds.',
        {count: secondsLeft}
      )}
    </Typography>
  );
}

export default WorkTimeSignOutCountdown;
